import { queryOptions } from '@tanstack/react-query';
import { NextRequest } from 'next/server';
import type { UserTraits } from 'scribe-networking/types';

import { fetcher } from '@/_lib/fetcher';

const USER_TRAITS_QUERY_KEY = 'user-traits';

export const getUserTraitsQueryKey = () => [USER_TRAITS_QUERY_KEY];

export const getUserTraits = ({ nextRequest }: { nextRequest?: NextRequest } = {}) =>
  fetcher.get<UserTraits>('users/me/traits/', { nextRequest });

export const getUserTraitsQueryOptions = () =>
  queryOptions({
    queryKey: getUserTraitsQueryKey(),
    queryFn: () => getUserTraits(),
    retry: false
  });
